// @ts-check

import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import _module from '@/store/base/module'
import i18n from '@/plugins/i18n'

const module = {
  state: {
    hot: {
      title: i18n.t('dashboard.userDashboard.hotTopicsWrapper.title'),
      subtitle: i18n.t('dashboard.userDashboard.hotTopicsWrapper.subtitle'),
      items: [],
      carouselType: 'hot'
    },
    featured: {
      title: i18n.t('dashboard.userDashboard.featureTopicsWrapper.title'),
      subtitle: i18n.t('dashboard.userDashboard.featureTopicsWrapper.subtitle'),
      items: [],
      carouselType: 'featured'
    },
    prime: {
      isPrime: true,
      title: i18n.t('dashboard.userDashboard.primeTopicsWrapper.title'),
      subtitle: i18n.t('dashboard.userDashboard.primeTopicsWrapper.subtitle'),
      items: [],
      carouselType: 'prime'
    },
    expertCmt: [{
      desc: i18n.t('dashboard.userDashboard.exportCmtDesc'),
      author: i18n.t('dashboard.userDashboard.exportCmtAuthor')
    }]
  },

  getters: {
    getHotTopics: state => {
      return state.hot
    },
    getFeaturedTopics: state => {
      return state.featured
    },
    getPrimeTopics: state => {
      return state.prime
    },
    getExpertCmt: state => {
      return state.expertCmt
    }
  },

  mutations: {
  },

  actions: {
    init: ({ state }) => {
      return ApiUtils.postData({
        data: {
          hot: {
            api: 'L0101ContentService.searchContents',
            input: {
              searchInfo: { not_prime: true },
              orderBy: { hottest: 'desc' },
              pagination: { current_page: 1, per_page: 10 }
            }
          },
          featured: {
            api: 'L0101ContentService.searchContents',
            input: {
              searchInfo: { not_prime: true },
              orderBy: { feature: 'desc' },
              pagination: { current_page: 1, per_page: 10 }
            }
          },
          prime: {
            api: 'L0101ContentService.searchContents',
            input: {
              searchInfo: { is_prime: true },
              orderBy: {},
              pagination: { current_page: 1, per_page: 10 }
            }
          }
        }
      }).then(data => {
        state.hot.items = data.hot.output.data
        state.featured.items = data.featured.output.data
        state.prime.items = data.prime.output.data
      })
    },
    search: ({ state }, payload) => {
      const data = {}

      payload.carouselType = payload.carouselType ?? 'all'

      if (payload.carouselType === 'hot' || payload.carouselType === 'all') {
        data.hot = {
          api: 'L0101ContentService.searchContents',
          input: {
            searchInfo: {
              not_prime: true,
              keyword: payload.keyword,
              target_content_type: payload.target_content_type
            },
            orderBy: { hottest: 'desc', sort_by: payload.sort_by },
            pagination: { current_page: 1, per_page: 10 }
          }
        }
      }

      if (payload.carouselType === 'featured' || payload.carouselType === 'all') {
        data.featured = {
          api: 'L0101ContentService.searchContents',
          input: {
            searchInfo: {
              not_prime: true,
              keyword: payload.keyword,
              target_content_type: payload.target_content_type
            },
            orderBy: { feature: 'desc', sort_by: payload.sort_by },
            pagination: { current_page: 1, per_page: 10 }
          }
        }
      }

      if (payload.carouselType === 'prime' || payload.carouselType === 'all') {
        data.prime = {
          api: 'L0101ContentService.searchContents',
          input: {
            searchInfo: {
              is_prime: true,
              keyword: payload.keyword,
              target_content_type: payload.target_content_type
            },
            orderBy: { sort_by: payload.sort_by },
            pagination: { current_page: 1, per_page: 10 }
          }
        }
      }

      return ApiUtils.postData({
        data: data
      }).then(data => {
        if (payload.carouselType === 'hot' || payload.carouselType === 'all') {
          state.hot.items = data.hot.output.data
        }
        if (payload.carouselType === 'featured' || payload.carouselType === 'all') {
          state.featured.items = data.featured.output.data
        }
        if (payload.carouselType === 'prime' || payload.carouselType === 'all') {
          state.prime.items = data.prime.output.data
        }
      })
    }
  }
}

export default ObjArrUtils.merge(_module, module)
